import React, { useEffect, useState } from "react";
import { apiPath } from "../../utility/Constant";
import useSession from "../../hooks/useSession";
import useFetch from "../../hooks/useFetch";
import Loading from "../../components/shared/loading/Loading";
import JobsCart from "./JobsCart";

const JobsPage = () => {
  const { jobsApi } = apiPath;
  const [user, loading] = useSession();
  const [jobsList, jobsListLoading] = useFetch(jobsApi, true);
  const [filteredData, setFilteredData] = useState([]);

  // sort by date
  useEffect(() => {
    //console.log(blogList);
    const data = [...jobsList]?.sort((a, b) => {
      return new Date(b.date) - new Date(a.date);
    });
    setFilteredData(data);
  }, [jobsList]);

  if (jobsListLoading || loading) {
    return <Loading />;
  }

  return (
    <div className="container mx-auto lg:pt-24 py-10 px-5 lg:px-16 ">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        <JobsCart />
        {filteredData?.map((job, index) => (
          <JobsCart key={index} job={job} user={user.role} />
        ))}
      </div>
    </div>
  );
};

export default JobsPage;
